import { render } from "./fieldFile.vue?vue&type=template&id=6d14227e&scoped=true"
import script from "./fieldFile.vue?vue&type=script&lang=js"
export * from "./fieldFile.vue?vue&type=script&lang=js"

import "./fieldFile.vue?vue&type=style&index=0&id=6d14227e&scoped=true&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d14227e"]])

export default __exports__